import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { objective: String, condition: String, max: Number, min: { type: Number, default: 0 } }

  connect() {
    this.allOptions = Array.from(this.objectiveSelect.options)
    this.filter()
  }

  filter() {
    const matches = this.conditionValue.split(",").includes(this.element.value)
    const rangeOptions = this.allOptions.filter(option => option.value && (matches ? Number(option.value) <= this.maxValue : Number(option.value) >= this.minValue))
    const selection = this.objectiveSelect.value

    this.objectiveSelect.replaceChildren(...this.allOptions.filter(option => !option.value), ...rangeOptions)
    this.objectiveSelect.value = rangeOptions.some(option => option.value === selection) ? selection : rangeOptions[0].value
  }

  get objectiveSelect() {
    return document.querySelector(this.objectiveValue)
  }
}
